import React from "react";
import { FormControl, TextField } from "@material-ui/core";

export default function Input(props) {
  return (
    <FormControl fullWidth className={props.className}>
      <TextField
        id={props.id}
        label={props.label}
        placeholder={props.placeholder}
        required={props.required}
        disabled={props.disabled ?? false}
        type={props.type}
        size={props.size}
        color={props.color || 'primary'}
        inputProps={{ maxLength: props.maxLength }}
        InputLabelProps={{ shrink: true }}
        value={props.value}
        onChange={(e) => props.setValue(e)}
        onFocus={props.setErro ? () => props.setErro(null) : null}
        error={props.erro ? true : false}
        helperText={props.erro}
        multiline={props.multiline}
        maxRows={props.maxRows ?? props.maxRows}
        variant={props.variant}
      />
    </FormControl>
  );
}
